import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import * as vdTask from './../vd-state/actions/vd.actions';

@Component({
  selector: 'app-build-visa-designer',
  templateUrl: './build-visa-designer.component.html',
  styleUrls: ['./build-visa-designer.component.scss']
})
export class BuildVisaDesignerComponent implements OnInit {
  buildNewVDTypeForm: FormGroup;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private store: Store<any>
  ) {
    this.buildNewVDTypeForm = new FormGroup({
      buildVisaType: new FormControl('build')
    });
  }

  ngOnInit() {
    // work around for primeng radio button
    this.buildNewVDTypeForm.get('buildVisaType').valueChanges.subscribe(e => {
      this.buildNewVDTypeForm.get('buildVisaType').setValue(e, { emitEvent: false });
    });
  }

  onSubmit() {
    this.store.dispatch(new vdTask.SetVDBuildType(this.buildNewVDTypeForm.get('buildVisaType').value));
    this.ref.close(true);
  }

  onCancel() {
    this.ref.close(false);
  }

}
